<template>
  <RouterView />
</template>

<style lang="scss">
@import "@/assets/css/base.scss";
@import "@/assets/css/layout.scss";

/** dynamic colors for wcag mode of web a11y */
:root {
  --spooky-ghost: #{$spooky-ghost};
  --lime: #{$lime};
  --mint: #{$mint};
  --important: #{$important};
  --orange: #{$orange};
  --tiger: #{$tiger};
  --cheek: #{$cheek};
  --coral: #{$coral};
  --link: #{$link};
  --tsuna: #{$tsuna};
  --text: #{$text};
}

.wcag-mode-on {
  --spooky-ghost: #{$wcag_spooky-ghost};
  --lime: #{$wcag_green};
  --mint: #{$wcag_green};
  --important: #{$wcag_important};
  --orange: #{$wcag_yellow};
  --tiger: #{$wcag_yellow};
  --cheek: #{$wcag_red};
  --coral: #{$wcag_red};
  --link: #{$wcag_link};
  --tsuna: #{$wcag_spooky-ghost};
  --text: #{$text};
}
</style>
